import React, { useState } from "react";

const questions = [
    {
        question: "Cosa significa AI?",
        options: ["Artificial Intelligence", "Automated Information", "Advanced Integration"],
        correct: 0
    },
    {
        question: "Chi è considerato il padre dell'AI?",
        options: ["Bill Gates", "Alan Turing", "Steve Jobs"],
        correct: 1
    },
    {
        question: "Cosa fa un algoritmo di Machine Learning?",
        options: ["Impara dai dati", "Scrive codice", "Ripara computer"],
        correct: 0
    },
    {
        question: "Cos'è una rete neurale?",
        options: ["Un cavo", "Un modello ispirato al cervello", "Un social network"],
        correct: 1
    },
    {
        question: "Cosa significa NLP?",
        options: ["New Learning Process", "Natural Language Processing", "Network Layer Protocol"],
        correct: 1
    }
];

export default function AITrivia() {
    const [currentQ, setCurrentQ] = useState(0);
    const [score, setScore] = useState(0);
    const [done, setDone] = useState(false);
    const [selected, setSelected] = useState(null);
    const [started, setStarted] = useState(false);

    const handleAnswer = (idx) => {
        setSelected(idx);
        if (idx === questions[currentQ].correct) setScore(score + 1);
        setTimeout(() => {
            if (currentQ + 1 < questions.length) {
                setCurrentQ(currentQ + 1);
                setSelected(null);
            } else {
                setDone(true);
            }
        }, 1000);
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-brain" style={{marginRight:"6px"}}></i> AI Trivia
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Quiz sull'Intelligenza Artificiale!</p>
                <button onClick={() => setStarted(true)} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#22c55e",marginBottom:"1rem"}}>
                    {score}/{questions.length}
                </p>
                <p style={{fontSize:"0.9rem",marginBottom:"1.5rem"}}>
                    {score === questions.length && "🤖 Esperto di AI!"}
                    {score >= 3 && score < questions.length && "👍 Buona conoscenza!"}
                    {score < 3 && "📚 Studia ancora l'AI!"}
                </p>
                <button onClick={() => {setStarted(true);setCurrentQ(0);setScore(0);setDone(false);setSelected(null);}} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Riprova
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Domanda {currentQ + 1} di {questions.length}
            </div>
            <h4 style={{color:"#facc15",marginBottom:"1.5rem",fontSize:"1rem"}}>
                {questions[currentQ].question}
            </h4>
            <div style={{display:"flex",flexDirection:"column",gap:"0.8rem"}}>
                {questions[currentQ].options.map((opt, i) => {
                    const isSelected = selected === i;
                    const isCorrect = i === questions[currentQ].correct;
                    const showFeedback = selected !== null;
                    return (
                        <button key={i} onClick={() => selected === null && handleAnswer(i)} disabled={selected !== null}
                                style={{padding:"0.8rem",borderRadius:"0.5rem",border:showFeedback?(isCorrect?"2px solid #22c55e":isSelected?"2px solid #ef4444":"1px solid rgba(255,255,255,0.1)"):"1px solid rgba(255,255,255,0.1)",background:showFeedback?(isCorrect?"rgba(34,197,94,0.2)":isSelected?"rgba(239,68,68,0.2)":"rgba(255,255,255,0.05)"):"rgba(255,255,255,0.05)",color:"#fff",cursor:selected===null?"pointer":"default",fontSize:"0.85rem"}}>
                            {showFeedback && isCorrect && <i className="fas fa-check" style={{marginRight:"6px",color:"#22c55e"}}></i>}
                            {showFeedback && isSelected && !isCorrect && <i className="fas fa-times" style={{marginRight:"6px",color:"#ef4444"}}></i>}
                            {opt}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}